import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ViewChild,
  AfterViewInit,
} from '@angular/core';
import { ToastContainerDirective, ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-core',
  template: `
    <lib-layout>
      <ng-container navigation>
        <app-presence></app-presence>
        <!-- <lib-chat-notification></lib-chat-notification> -->
        <app-user-profile></app-user-profile>
      </ng-container>
      <ng-container sidebar>
        <app-menu-switch></app-menu-switch>
      </ng-container>
      <ng-container blade>
        <div>Blade Content</div>
      </ng-container>
    </lib-layout>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CoreComponent {
  constructor(private toastr: ToastrService) {}
}
